import { render, staticRenderFns } from "./dictionary-import.vue?vue&type=template&id=d094c8c4&scoped=true"
import script from "./dictionary-import.vue?vue&type=script&lang=js"
export * from "./dictionary-import.vue?vue&type=script&lang=js"
import style0 from "./dictionary-import.vue?vue&type=style&index=0&id=d094c8c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d094c8c4",
  null
  
)

export default component.exports